import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  TOGGLE_TRAILHEADS_TRIPS,
  SELECT_LIST_ITEM,
  DESELECT_LIST_ITEM,
} from '../common/actionTypes';

export const sidebarOpen = () => ({
  type: SIDEBAR_OPEN,
});

export const sidebarClose = () => ({
  type: SIDEBAR_CLOSE,
});

export const toggleTraiheadsTrips = () => ({
  type: TOGGLE_TRAILHEADS_TRIPS,
});



// WEBPACK FOOTER //
// ./map/actions/sidebarActions.js